up.compiler('.js-filter_wrapper', async function (wrapper) {
  const { createVueApp } = await import(/* webpackChunkName: "create_vue_app" */ '../create_vue_app')
  const { OnClickOutside } = await import(/* webpackChunkName: "vClickOutside" */ '@vueuse/components')

  const el = wrapper.querySelector('.js-filter')
  const initialData = JSON.parse(el.querySelector('form').dataset.initialData)
  const data = Object.assign(initialData, {
    initialData: Object.assign({}, initialData),
    expanded: false
  })

  const app = createVueApp({
    components: { OnClickOutside },
    data() {
      return data
    },
    computed: {
      anyChecked() {
        return this[this.filterName].length > 0
      }
    },
    methods: {
      toggle(event) {
        this.expanded = !this.expanded
      },
      hideAndReset(event) {
        this.expanded = false
        this[this.filterName] = this.initialData[this.filterName]
      },
      selectAll(event) {
        this[this.filterName] = this.allOptions
      },
      unselectAll(event) {
        this[this.filterName] = []
      }
    }
  })

  app.mount(el)

  up.destructor(wrapper, () => {
    app.unmount()
  })
})
